export const exportJobsToExcel = (jobs) => {
    if (!jobs || jobs.length === 0) {
        return;
    }

    const headers = [
        'Job #',
        'Client Name',
        'Title',
        'Service Type',
        'Boat Type',
        'Boat Location',
        'Schedule',
        'Status',
        'Location',
        'Total Visits',
        'Start Date',
        'Start Time',
        'End Time',
        'Notes',
    ];

    const rows = jobs.map(job => {
        const quote = job.raw?.quote || {};
        const clientName = `${quote.first_name || ''} ${quote.last_name || ''}`.trim() || 'Unknown Client';
        
        return [
            job.jobNumber || '',
            clientName,
            job.title || '',
            quote.boat_type || '',
            quote.boat_type || '',
            quote.boat_location || '',
            job.schedule || '',
            job.status || '',
            job.raw?.location || '',
            job.raw?.total_visits || '',
            job.raw?.start_date || '',
            job.raw?.start_time || '',
            job.raw?.end_time || '',
            job.raw?.notes || '',
        ];
    });

    const csvContent = [
        headers.join(','),
        ...rows.map(row => 
            row.map(cell => {
                const cellValue = String(cell || '').replace(/"/g, '""');
                return `"${cellValue}"`;
            }).join(',')
        )
    ].join('\n');

    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    const timestamp = new Date().toISOString().split('T')[0];
    link.setAttribute('href', url);
    link.setAttribute('download', `jobs_export_${timestamp}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(url);
};

